module.exports = __webpack_public_path__ + "img/bystyle.b3aec7b.webp";